import React from "react";
import { DotLegalDialog } from "@dotlegal/dotlegal-ui-components";

export interface IDotLegalPlayer {
    url: string;
    onCloseDialog: () => void;
}

function DotLegalPlayer(props: IDotLegalPlayer) {
    return (
        <DotLegalDialog size="lg" hideOkButton buttonOkText={""} open onDialogClose={props.onCloseDialog} onOkClick={() => {}}>
            <video src={props.url} controls autoPlay style={{ width: "100%", height: "100%" }} />
        </DotLegalDialog>
    );
}

export default DotLegalPlayer;
